import NotFoundTemplate from "@components/templates/NotFoundTemplate";
import React from "react";

const TftSummonerSearchTemplate = () =>
  <NotFoundTemplate/>;
export default TftSummonerSearchTemplate;
